import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { ShippingProvider } from './shipping-provider.enum';
import { ShippingStatus } from './shipping.status.enum';
import { ShippingType } from './shipping.type.enum';

export const ShippingSchema = WithBaseEntitySchema(
    z.object({
        invoice: z.string().nullish(),
        buyer: z.string().nullish(),
        type: EnumSchema(ShippingType),
        shippingProvider: EnumSchema(ShippingProvider),
        trackingNumber: z.string().regex(/^[a-zA-Z0-9.-]+$/),
        trackingUrl: z.string().optional().nullish(),
        status: EnumSchema(ShippingStatus),
    }),
).strict();

export class Shipping extends FromSchema(ShippingSchema) implements BaseEntity {
    id: string;
    invoice?: string;
    buyer?: string;
    type: ShippingType;
    shippingProvider: ShippingProvider;
    trackingNumber: string;
    trackingUrl?: string;
    status: ShippingStatus;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    tenantId: string;
    seller: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
